import { map } from 'rxjs/operators';
import { Component, OnInit, Input } from '@angular/core';
import { DVFormArray, DVFormGroup, DVFormControl } from 'src/app/shared/helpers/dynamic-validators/dynamic-validator';
import { Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SnotifyService } from 'ng-snotify';
import _ from 'lodash';
import moment from 'moment';
import { PackagesService } from '../packages.service';

@Component({
  selector: 'app-add-image-alt',
  templateUrl: './add-image-alt.component.html',
  styleUrls: ['./add-image-alt.component.css']
})
export class AddImageAltComponent implements OnInit {
  packageForm: DVFormGroup;
  isAddState = true;
  imageAlts: [];
  days: [];
  packageData: any;
  constructor(
    public route: ActivatedRoute,
    private packageApi: PackagesService,
    private notifier: SnotifyService,
    private router: Router
  ) {
    this.packageForm = new DVFormGroup({
      id: new DVFormControl(null),
      ExperiencePictures: new DVFormGroup({
        id: new DVFormControl(),
        url: new DVFormControl(),
        alt: new DVFormControl(),
      })
    });
  }

  ngOnInit() {
    this.initiateAltImageMode();
  }

  formSubmit(active?: boolean) {
    if (this.packageForm.valid) {
      const formResult = this.packageForm.getCleanValue();
      delete this.packageData.experience.price;
      delete this.packageData.experience.picture;
      delete this.packageData.experience.pictureAlt;
      delete this.packageData.experience.adminApproval;
      delete this.packageData.experience.index;
      delete this.packageData.experience.verified;
      delete this.packageData.experience.createdBy;
      delete this.packageData.experience.locationId;
      delete this.packageData.experience.createdAt;
      delete this.packageData.experience.updatedAt;
      delete this.packageData.experience.deletedAt;
      delete this.packageData.experience.Tags;
      delete this.packageData.experience.Accommodations;
      delete this.packageData.experience.RelatedExperiences;
      delete this.packageData.experience.City;
      delete this.packageData.experience.Locals;
      delete this.packageData.experience.ExperienceTypes;
      delete this.packageData.experience.OnlineExperienceDetails;

      delete this.packageData.experience.ExperienceCancellationPolicies;
      delete this.packageData.experience.Location;
      delete this.packageData.experience.Price;
      delete this.packageData.experience.active;
      delete this.packageData.experience.cityId;
      delete this.packageData.experience.createdAt;
      delete this.packageData.experience.createdBy;
      delete this.packageData.experience.deletedAt;
      delete this.packageData.experience.description;
      delete this.packageData.experience.discount;
      delete this.packageData.experience.duration;
      delete this.packageData.experience.endDate;
      delete this.packageData.experience.excluded;
      delete this.packageData.experience.facts;
      delete this.packageData.experience.highlights;
      delete this.packageData.experience.included;

      delete this.packageData.experience.index;
      delete this.packageData.experience.maximumCapacity;
      delete this.packageData.experience.metaDescription;
      delete this.packageData.experience.metaKeywords;
      delete this.packageData.experience.metaTitle;
      delete this.packageData.experience.name;

      delete this.packageData.experience.startDate;
      delete this.packageData.experience.startIndex;
      delete this.packageData.experience.tagline;
      delete this.packageData.experience.updatedAt;
      delete this.packageData.experience.verified;
      delete this.packageData.experience.videoUrl;
      delete this.packageData.experience.ExperienceDays;
      delete this.packageData.experience.PackageDetails;
      console.log( this.packageData , ">>>>>>>>>");

      for (let index = 0; index < this.packageData.experience.ExperiencePictures.length; index++) {
          delete this.packageData.experience.ExperiencePictures[index].caption;
          delete this.packageData.experience.ExperiencePictures[index].cityId;
          delete this.packageData.experience.ExperiencePictures[index].experienceId;
          delete this.packageData.experience.ExperiencePictures[index].accommodationId;
          delete this.packageData.experience.ExperiencePictures[index].localId;
          delete this.packageData.experience.ExperiencePictures[index].activityId;
          delete this.packageData.experience.ExperiencePictures[index].createdAt;
          delete this.packageData.experience.ExperiencePictures[index].updatedAt;
      }

      this.performEditOperation( this.packageData.experience, this.packageData.experience.id);
    } else {
      this.packageForm.forceShowErrors();
    }
  }


  private initiateAltImageMode() {
    const experienceId = this.route.snapshot.params.id;
    this.packageApi.getSinglePackageById(experienceId).subscribe(response => {
      const packageBody = response.data.experience;
      this.packageData = response.data;
      // this.packageData.experienceTypes = this.packageData.ExperienceTypes;
      this.imageAlts = packageBody.ExperiencePictures;
      this.days = packageBody.ExperienceDays
      console.log('Experience Body >>> ', response.data);
      this.imageAlts = packageBody.ExperiencePictures.map((day, index) => ({
        id: day.id,
        url: day.url,
        alt: day.alt
      }));

      this.packageForm.patchValue(packageBody);
    });
  }

  addAlt (event) {
    const formResult = this.packageForm.getCleanValue();
    const altTitle = event.target.value;
    const imageId = event.target.id;
    for (let index = 0; index < this.packageData.experience.ExperiencePictures.length; index++) {
      const image = this.packageData.experience.ExperiencePictures[index];
      if (image.id == imageId) {
        this.packageData.experience.ExperiencePictures[index].alt = altTitle;
        // delete this.packageData.experience.ExperiencePictures[index].caption;
        // delete this.packageData.experience.ExperiencePictures[index].cityId;
        // delete this.packageData.experience.ExperiencePictures[index].experienceId;
        // delete this.packageData.experience.ExperiencePictures[index].accommodationId;
        // delete this.packageData.experience.ExperiencePictures[index].localId;
        // delete this.packageData.experience.ExperiencePictures[index].activityId;
        // delete this.packageData.experience.ExperiencePictures[index].createdAt;
        // delete this.packageData.experience.ExperiencePictures[index].updatedAt;
        return;
      }
    }
  }

  addAltActivity (event) {
    const formResult = this.packageForm.getCleanValue();
    const altTitle = event.target.value;
    const imageId = event.target.id;
    // console.log(this.packageData, 'rrrrrrrrrrrrr', altTitle, imageId);
    for (let index = 0; index < this.packageData.experience.ExperienceDays.length; index++) {
      const day = this.packageData.experience.ExperienceDays[index];
      for (let index2 = 0; index2 < day.Activities.length; index2++) {
        const activity = day.Activities[index2];
        for (let index3 = 0; index3 < activity.Pictures.length; index3++) {
          const image = activity.Pictures[index3];
          console.log('image', image, imageId);
          if (image.id == imageId) {
            this.packageData.experience.ExperienceDays[index].Activities[index2].Pictures[index3].alt = altTitle;
            console.log(this.packageData.experience.ExperienceDays[index].Activities[index2].Pictures[index3]);
            return;
          }
        } 
        console.log(this.packageData.experience, 'aaaaaaaaaa');
        
      }
      
    }
  }
  private performEditOperation(packageFormBody, experienceId) {
    this.packageApi.updatePackagePicture(packageFormBody, experienceId).subscribe(response => {
      this.notifier.success('Package Editted Successfully');
      this.router.navigate(['/packages/list']);
    }, error => {
      this.notifier.error(error.error.userMessage);
    });
  }

}
export class AttachedFileModel {
  id: string;
  name: string;
  type: string;
  /**
   *
   */
  constructor() {
    this.id = '';
    this.name = '';
    this.type = '';
  }
}
interface DateClickInterface {
  alt: string;
  jsEvent: MouseEvent;
}